import React, { useEffect, useState, useRef, useCallback } from "react";
import { useSelector } from "react-redux";
import "./AnnouncementBanner.styles.scss";

const MAX_TIMEOUT_MS = 2 ** 31 - 1;

const AnnouncementBanner = () => {
  const announcement = useSelector((state) => state.announcement);
  const [visible, setVisible] = useState(false);
  const bannerRef = useRef(null);

  const updateBannerHeight = useCallback(() => {
    if (bannerRef.current) {
      const height = bannerRef.current.offsetHeight;
      document.documentElement.style.setProperty("--announcement-banner-height", `${height}px`);
    }
  }, []);

  useEffect(() => {
    if (!announcement || !announcement.isActive) {
      setVisible(false);
      return;
    }

    const timeUntilExpiry = new Date(announcement.expiresAt).getTime() - Date.now();

    if (timeUntilExpiry <= 0) {
      setVisible(false);
      return;
    }

    setVisible(true);

    const scheduleExpiry = () => {
      const remaining = new Date(announcement.expiresAt).getTime() - Date.now();
      if (remaining <= 0) {
        setVisible(false);
        return null;
      }
      return setTimeout(() => {
        if (remaining > MAX_TIMEOUT_MS) {
          timerId = scheduleExpiry();
        } else {
          setVisible(false);
        }
      }, Math.min(remaining, MAX_TIMEOUT_MS));
    };

    let timerId = scheduleExpiry();

    return () => { if (timerId) clearTimeout(timerId); };
  }, [announcement]);

  useEffect(() => {
    if (!visible) {
      document.documentElement.style.setProperty("--announcement-banner-height", "0px");
      return;
    }

    updateBannerHeight();
    window.addEventListener("resize", updateBannerHeight);

    return () => {
      window.removeEventListener("resize", updateBannerHeight);
      document.documentElement.style.setProperty("--announcement-banner-height", "0px");
    };
  }, [visible, updateBannerHeight]);

  if (!visible || !announcement) return null;

  const colorClass = announcement.color || "info";

  return (
    <div ref={bannerRef} className={`announcement-banner announcement-banner--${colorClass}`}>
      <span className="announcement-banner__text">{announcement.message}</span>
    </div>
  );
};

export default AnnouncementBanner;
